var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "#fff"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.917 8.708c0 2.974 2.527 5.419 5.66 5.419 1.184 0 2.29-.353 3.264-1.009l.79-.529.552-.756c.685-.932 1.053-1.99 1.053-3.125 0-2.974-2.527-5.419-5.66-5.419s-5.66 2.445-5.66 5.419m-2.817 0C.1 4.222 3.89.593 8.576.593s8.477 3.629 8.477 8.115c0 1.739-.58 3.352-1.58 4.688L19.45 17.2c.263.252.42.605.42.958s-.13.706-.42.958l-.027.025c-.553.53-1.474.605-2 0l-3.95-3.806c-1.394.933-3.08 1.513-4.896 1.513C3.891 16.823.1 13.194.1 8.708"
  })));
};
export default SvgSearch;